import { Engine, Runner, Render, Bodies, Composite, Body, Events, Vector, Mouse, MouseConstraint, Query, World } from 'matter-js';

import { gsap } from 'gsap';

const THICKNESS = 1;

export default class Toolbox {
    constructor(element) {
        this._wrapper = element;
        this._world = this._wrapper.querySelector('.js-toolbox-virtual-world');
        this._frontWorld = this._wrapper.querySelector('.js-toolbox-world');
        
        this._shapes = this._wrapper.querySelectorAll('[class^="js-toolbox-world-circle"], [class^="js-toolbox-world-rect"], [class^="js-toolbox-world-triangle"]');
        this._circles = this._wrapper.querySelectorAll('[class^="js-toolbox-world-circle"]');
        this._rects = this._wrapper.querySelectorAll('[class^="js-toolbox-world-rect"]');
        this._triangles = this._wrapper.querySelectorAll('[class^="js-toolbox-world-triangle"]');
        this._btn = this._wrapper.querySelector('.js-toolbox-world-btn');
        
        this.worldWidth = this._world.offsetWidth;

        this.positions = {
            rectA: {
                x:this.isMobile() ? 170 : 195,
                y:this.isMobile() ? 0 : 300,
            },
            rectB : {
                x:this.isMobile() ? 300 : 1302,
                y:this.isMobile() ? 350 : 0,
            },
            circleA : {
                x:this.isMobile() ? 200 : 0,
                y:this.isMobile() ? 0 : 0,
            },
            circleB : {
                x:this.isMobile() ? 0 : 735,
                y:this.isMobile() ? 314 : 347,
            },
            triangleA: {
                x:this.isMobile() ? 66 : 261,
                y:this.isMobile() ? 380 : 0,
            },
            triangleB: {
                x:this.isMobile() ? 0 : 1042,
                y:this.isMobile() ? 300 : 380,
            }
        }
        
        this.isInit = false;
        
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
               if(entry.isIntersecting){
                   if(!this.isInit){
                       if(this.isMobile()){
                           setTimeout(() => {
                               this.init();
                           }, 250)
                       }
                       else{
                           this.init();
                       }
                   }
               } 
            });
        },  {threshold:0.5});
        
        this.observer.observe(this._frontWorld);
        // this.init();
        
        this.bindEvents();
    }

    init() {
        this._frontWorld.classList.add('is-init');
        this.engine = Engine.create({
        });
        // this.engine.gravity.y = 0;
        this.render = Render.create({
            element:this._world,
            engine:this.engine,
            options:{
                width:this._world.offsetWidth,
                height:this._world.offsetHeight,
                background:'transparent',
                wireframes:true,
                showAngleIndicator:true,
            }
        });
        this.runner = Runner.create({
            delta: 1000 / (60 * 10),
            maxFrameTime: 1000 / 50
        });

        this.mouse = Mouse.create(this.render.canvas);

        this.bodies = [];
        
        
        this.createsRectangles();
        this.createCircles();
        this.createBoundaries();
        this.createTriangles();
        
        this.mouseConstraint = MouseConstraint.create(this.engine, {
           mouse:this.mouse,
           constraint:{
               stiffness:0.2,
               render:{
                   visible:true
               }
           } 
        });
        
        // Mouseover
        // Events.on(this.mouseConstraint, 'mousemove',  (event)  => {
        //     var foundPhysics = Query.point(this.bodies, event.mouse.position);
        //     if(foundPhysics[0]){
        //         foundPhysics[0].elem.classList.add('is-hover');
        //     }
        //     else{
        //         this.bodies.forEach((el) => {
        //            el.elem.classList.remove('is-hover'); 
        //         });
        //     }
        //
        // });
        
        
        Composite.add(this.engine.world, this.mouseConstraint);
        
        Render.run(this.render);
        Runner.run(this.runner, this.engine);
        this.isInit = true;
    }
    
    createsRectangles(){
        this.matterRectangles = [];
        if(this._rects.length){
            
            this.rectangleDimensions = {
                width : this._rects[0].offsetWidth,
                height: this._rects[0].offsetHeight
            }
            
            let _rectAElem = document.querySelector('.js-toolbox-world-rect-a');
            let _rectBElem = document.querySelector('.js-toolbox-world-rect-b');
            
            //Rect A
            let rectAPosition = this.setPosition(this.getPercentX(this.positions.rectA.x), this.positions.rectA.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
            this.rectA = Bodies.rectangle(rectAPosition.x, rectAPosition.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
            this.rectA .elem = _rectAElem;
            
            Events.on(this.runner, "tick", () => {
                this.syncElemWithMatter(this.rectA.elem, this.rectA, this.rectangleDimensions.width, this.rectangleDimensions.height);
            })

            this.matterRectangles.push(this.rectA);
            this.bodies.push(this.rectA);
            
            //Rect B
            if(_rectBElem){
                let rectBPosition = this.setPosition(this.getPercentX(this.positions.rectB.x), this.positions.rectB.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
                this.rectB = Bodies.rectangle(rectBPosition.x, rectBPosition.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
                this.rectB.elem = _rectBElem;

                Events.on(this.runner, "tick", () => {
                    this.syncElemWithMatter(this.rectB.elem, this.rectB, this.rectangleDimensions.width, this.rectangleDimensions.height);
                })

                this.matterRectangles.push(this.rectB);
                this.bodies.push(this.rectB);
            }

            Composite.add(this.engine.world, this.matterRectangles);
        }
    }
    
    createCircles(){
        this.matterCircles = [];
        if(this._circles.length){
            
            this.circleDiameter = this._circles[0].offsetWidth;


            let _circleAElem = document.querySelector('.js-toolbox-world-circle-a');
            let _circleBElem = document.querySelector('.js-toolbox-world-circle-b');
            
            //Circle A;
            let circlePositionA = this.setPosition(this.positions.circleA.x,this.positions.circleA.y , this.circleDiameter, this.circleDiameter);
            this.circleA = Bodies.circle(circlePositionA.x, circlePositionA.y, this.circleDiameter / 2);
            this.circleA.elem = _circleAElem;
            

            Events.on(this.runner, "tick", () => {
                this.syncElemWithMatter(this.circleA.elem, this.circleA, this.circleDiameter, this.circleDiameter);
            })
            
            this.matterCircles.push(this.circleA);
            this.bodies.push(this.circleA);
            
            //Circle B;
            if(_circleBElem){
                let circlePositionB = this.setPosition(this.getPercentX(this.positions.circleB.x),this.positions.circleB.y, this.circleDiameter, this.circleDiameter);
                this.circleB = Bodies.circle(circlePositionB.x, circlePositionB.y, this.circleDiameter / 2);
                this.circleB.elem = _circleBElem;
                
                Events.on(this.runner, "tick", () => {
                    this.syncElemWithMatter(this.circleB.elem, this.circleB, this.circleDiameter, this.circleDiameter);
                })

                this.matterCircles.push(this.circleB);
                this.bodies.push(this.circleB);
            }
            
            Composite.add(this.engine.world, this.matterCircles);
        }
    };
    
    createTriangles(){
        this.matterTriangles = [];
        if(this._triangles.length){
            
            this.triangleDimensions = {
                width : this._triangles[0].offsetWidth,
                height: this._triangles[0].offsetHeight
            }
            
            const vertices = [
                { x: this.triangleDimensions.width / 2, y: 0 },     // Sommet supérieur
                { x: 0, y: this.triangleDimensions.height },     // Bas gauche
                { x: this.triangleDimensions.width, y: this.triangleDimensions.height }    // Bas droit
            ];
            
            let _triangleAElem = document.querySelector('.js-toolbox-world-triangle-a');
            let _triangleBElem = document.querySelector('.js-toolbox-world-triangle-b');
            
            // Triangle A
            let trianglePositionA = this.setPosition(this.getPercentX(this.positions.triangleA.x),this.positions.triangleA.y, this.triangleDimensions.width, this.triangleDimensions.height);
            this.triangleA = Bodies.fromVertices(trianglePositionA.x, trianglePositionA.y, [vertices]);
            this.triangleA.elem = _triangleAElem;

            this.matterTriangles.push(this.triangleA);
            this.bodies.push(this.triangleA);
            
            Events.on(this.runner, "tick", () => {
                this.syncElemWithMatter(this.triangleA.elem, this.triangleA, this.triangleDimensions.width, this.triangleDimensions.height);
            });
            
            // Triangle B
            if(_triangleBElem){

                let trianglePositionB = this.setPosition(this.getPercentX(this.positions.triangleB.x),this.positions.triangleB.y, this.triangleDimensions.width, this.triangleDimensions.height);
                this.triangleB = Bodies.fromVertices(trianglePositionB.x, trianglePositionB.y, [vertices]);
                this.triangleB.elem = _triangleBElem;
                
                this.matterTriangles.push(this.triangleB);
                this.bodies.push(this.triangleB);

                Events.on(this.runner, "tick", () => {
                    this.syncElemWithMatter(this.triangleB.elem, this.triangleB, this.triangleDimensions.width, this.triangleDimensions.height);
                });
            }

            Composite.add(this.engine.world, this.matterTriangles);
        }
    }
    
    bindEvents(){
        window.addEventListener('resize', app.debounce(this.onResize.bind(this)));
        
        
        // Button download
        let ease = 'power2.out';
        this._frontWorld.addEventListener('mousemove', (e) => {
           gsap.to(this._btn, {x:e.clientX - this._frontWorld.getBoundingClientRect().left + 20, y:e.clientY - this._frontWorld.getBoundingClientRect().top + 20, ease:ease});
        });
        app.nodesEventListener('mouseenter', this._shapes, () => {
           gsap.to(this._btn, {alpha:1, scale:1, ease:ease});
        });
        app.nodesEventListener('mouseleave', this._shapes, () => {
            gsap.to(this._btn, {alpha:0, scale:0, ease:ease});
        });
    }
    
    createBoundaries(){
        this.left = Bodies.rectangle(0, 0, THICKNESS, 9999, { isStatic: true });
        this.right = Bodies.rectangle(this._world.offsetWidth, 0, THICKNESS, 9999, { isStatic: true });
        this.bottom = Bodies.rectangle(this._world.offsetWidth / 2, this._world.offsetHeight, 9999, THICKNESS, { isStatic: true });
        Composite.add(this.engine.world, [this.bottom, this.left, this.right]);
    }
    
    onResize(){
        // this.render.canvas.width = this._world.offsetWidth;
        // this.render.canvas.height = this._world.offsetHeight;
        // Body.setPosition(this.bottom, Vector.create(this._world.offsetWidth / 2, this._world.offsetHeight));
        // Body.setPosition(this.left, Vector.create(0,0));
        // Body.setPosition(this.right, Vector.create(this._world.offsetWidth, 0));
        // Body.setPosition(this.top, Vector.create(this._world.offsetWidth / 2));
        if(this.worldWidth !== this._world.offsetWidth){ // check for width because of IOS resize event trigger on scroll
            this.worldWidth = this._world.offsetWidth;
            Engine.clear(this.engine);

            Render.stop(this.render);

            Runner.stop(this.runner);

            World.clear(this.engine.world, false);

            Events.off(this.engine);
            Events.off(this.render);

            this.engine = null;
            this.render = null;
            this.runner = null;
            this.isInit = false;
            this._frontWorld.classList.remove('is-init');
            this.init();
        }
        
    }
    
    getPercentX(x){
        let baseSize = 1920;
        let percentFromBaseSize = x / baseSize ;
        let currentSize = this._world.offsetWidth;
        return currentSize * percentFromBaseSize;
        
    }
    
    setPosition(x,y,width,height){
        return {
            x:width / 2 + x,
            y: height / 2 +y,
        }
    }
    
    isMobile(){
        return window.matchMedia('(max-width:768px)').matches;
    }

    syncElemWithMatter(divElement, body, bodyWidth, bodyHeight) {
        let angle = body.angle;
        let scale = 1; 

        divElement.style.transform = `translate(${body.position.x - bodyWidth / 2}px, ${body.position.y - bodyHeight / 2}px) rotate(${angle}rad) scale(${scale})`;

    }
}
